import { render, staticRenderFns } from "./ItemListUserItemLayout.vue?vue&type=template&id=443185a9&scoped=true"
import script from "./ItemListUserItemLayout.vue?vue&type=script&lang=js"
export * from "./ItemListUserItemLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443185a9",
  null
  
)

export default component.exports